var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5212",
    "data-name": "Group 5212",
    transform: "translate(20802 13034)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1628",
    "data-name": "Rectangle 1628",
    width: 48,
    height: 48,
    transform: "translate(-20802 -13034)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-create-new-page-4942608",
    transform: "translate(-20793.922 -13030.471)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13133",
    "data-name": "Path 13133",
    d: "M36.638,20.326V13.2H17.82V50.205H45.732V22.294H38.606A1.968,1.968,0,0,1,36.638,20.326Zm3.012,14.33a.984.984,0,0,1-.984.984H32.76v5.905a.984.984,0,1,1-1.968,0V35.639H24.886a.984.984,0,0,1,0-1.968h5.905V27.766a.984.984,0,1,1,1.968,0v5.905h5.905A.984.984,0,0,1,39.649,34.655Z",
    transform: "translate(-15.852 -11.232)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13134",
    "data-name": "Path 13134",
    d: "M38.94,14.61v5.738h5.738Z",
    transform: "translate(-16.186 -11.254)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13135",
    "data-name": "Path 13135",
    d: "M47.59,20.9a.915.915,0,0,0-.207-.325l-9.094-9.094a.984.984,0,0,0-.315-.207,1.073,1.073,0,0,0-.384-.079h-19.8a1.968,1.968,0,0,0-1.968,1.968V50.174a1.968,1.968,0,0,0,1.968,1.968H45.7a1.968,1.968,0,0,0,1.968-1.968v-28.9A.984.984,0,0,0,47.59,20.9Zm-9.015-6.348,5.738,5.738H38.574ZM45.7,50.174H17.788V13.168H36.606v7.126a1.968,1.968,0,0,0,1.968,1.968H45.7Z",
    transform: "translate(-15.82 -11.2)",
    fill: "#212a42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13136",
    "data-name": "Path 13136",
    d: "M32.858,27.984a.984.984,0,0,0-1.968,0v5.905H24.984a.984.984,0,0,0,0,1.968h5.905v5.905a.984.984,0,1,0,1.968,0V35.858h5.905a.984.984,0,0,0,0-1.968H32.858Z",
    transform: "translate(-15.949 -11.45)",
    fill: "#212a42"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPageIcon);
export default __webpack_public_path__ + "static/media/NewPageIcon.9fd351ee4b2779a551a4de289067f350.svg";
export { ForwardRef as ReactComponent };